var badWordRegex = require('./regex-bad-words');

function testAdditionalWords(additionalWords) {
  return new RegExp('\\b(' + additionalWords.join('|').toUpperCase() + ')\\b', 'gm');
}

function getMatches(text, regex) {
  var matches;
  var textToMatch = text.toUpperCase();
  var result = {
    input: text,
    matches: [],
  };

  if (text.length < 3) {
    return result;
  }

  // eslint-disable-next-line no-cond-assign
  while ((matches = regex.exec(textToMatch)) !== null) {
    result.matches.push({
      match: matches[0],
      index: matches.index,
    });
  }

  return result;
}

function getBadWordMatches(text, words) {
  var badWordMatches;
  var additionalWordsRegex;
  var additionalMatches;

  var additionalWords = (words || {}).additionalWords || [];

  if (typeof text !== 'string') {
    throw new Error('expecting [string] input');
  }

  badWordMatches = getMatches(text, badWordRegex);

  // this could slow things down significantly for ad-hoc additonal word checking
  // prefer adding permanently to dictionary if possible
  if (additionalWords.length > 0) {
    additionalWordsRegex = testAdditionalWords(additionalWords);
    additionalMatches = getMatches(text, additionalWordsRegex);
    badWordMatches.matches = [].concat(badWordMatches.matches, additionalMatches.matches);
  }

  return badWordMatches;
}

exports.getBadWordMatches = getBadWordMatches;

function containsBadWord(text, words) {
  var textToMatch;

  var additionalWords = (words || {}).additionalWords || [];

  if (typeof text !== 'string') {
    throw new Error('expecting [string] input');
  }

  if (text.length === 0) {
    return false;
  }

  textToMatch = text.toUpperCase();

  if ((textToMatch.match(badWordRegex) || []).length > 0) {
    return true;
  }

  // this could slow things down significantly for ad-hoc additonal word checking
  // prefer adding permanently to dictionary if possible
  return additionalWords.length > 0
    ? (textToMatch.match(testAdditionalWords(additionalWords)) || []).length > 0
    : false;
}

exports.containsBadWord = containsBadWord;
